import React from "react";
import dash from "../img/dashed.png"
import WomanArray from "../Arrays/WomanArray";



// import Modal from 'react-bootstrap/Modal';
import { useState } from 'react'

const Woman = () => {
    

    const [modalShow, setModalShow] = useState(false);
    const [imgVal, setImgVal] = useState("");
    const [caption, setCaption] = useState("");
    const [currentIndex, setCurrentIndex] = useState(0);

    const imgArry = WomanArray.map((media) => media.img);


    const closeModal = () => {
        setModalShow(false);
        setImgVal("");
        setCaption("");
    };

    const prevImg = () => {
        const newIndex = (currentIndex - 1 + imgArry.length) % imgArry.length;
        setCurrentIndex(newIndex);
        setImgVal(imgArry[newIndex]);
    };

    const nextImg = () => {
        const newIndex = (currentIndex + 1) % imgArry.length;
        setCurrentIndex(newIndex);
        setImgVal(imgArry[newIndex]);
    };

    const ImgElement = (props) => {
        return (
            <>
                <span className={`${props.position} cursor-pointer`} >
                    <img src={props.img} alt='' className="media" onClick={() => { setModalShow(true); setImgVal(props.img) }} />
                </span>
            </>
        )
    }

    return (
        <>
            <div className="container mt-5" id="WomanTeam">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <h2 className="Headers mb-0 fs-lg-3 fs-md-3 fs-sm-2">Women's Wheelchair Cricket</h2>
                        <img src={dash} className="mx-auto" alt="" />
                    </div>
                    <div className="row">
                        <div className="col-md-5 my-auto" >
                            <div className="media-container">
                                {WomanArray.map((value, index) => {
                                    return (
                                        <ImgElement img={value.img} key={index} size={value.size} position={value.position} />
                                    )
                                })}


                                {modalShow && (
                                    <div
                                        className="custom-modal-overlay"
                                        style={{
                                            position: "fixed",
                                            top: 0,
                                            left: 0,
                                            width: "100vw",
                                            height: "100vh",
                                            backgroundColor: "rgba(0,0,0,0.9)",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            zIndex: 9999,
                                        }}
                                    >
                                        {/* Close Button */}
                                        <span
                                            onClick={closeModal}
                                            style={{
                                                position: "absolute",
                                                top: "20px",
                                                right: "30px",
                                                color: "#fff",
                                                fontSize: "30px",
                                                fontWeight: "bold",
                                                cursor: "pointer",
                                                zIndex: 1000,
                                            }}
                                        >
                                            &times;
                                        </span>

                                        {/* Prev Button */}
                                        <button
                                            onClick={prevImg}
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "20px",
                                                transform: "translateY(-50%)",
                                                fontSize: "2rem",
                                                color: "#fff",
                                                background: "none",
                                                border: "none",
                                                cursor: "pointer",
                                            }}
                                        >
                                            &#10094;
                                        </button>

                                        {/* Image */}
                                        <img
                                            src={imgVal}
                                            alt=""
                                            style={{
                                                maxWidth: "90vw",
                                                maxHeight: "90vh",
                                                objectFit: "contain",
                                                boxShadow: "0 0 20px #000",
                                            }}
                                        />

                                        {/* Next Button */}
                                        <button
                                            onClick={nextImg}
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                right: "20px",
                                                transform: "translateY(-50%)",
                                                fontSize: "2rem",
                                                color: "#fff",
                                                background: "none",
                                                border: "none",
                                                cursor: "pointer",
                                            }}
                                        >
                                            &#10095;
                                        </button>

                                        {/* Caption */}
                                        {caption && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    bottom: "20px",
                                                    color: "#fff",
                                                    textAlign: "center",
                                                    width: "100%",
                                                }}
                                            >
                                                {caption}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-7 my-auto">
                            <p className="text-justify paragraph">As BCCI has taken women's cricket under their wing & started Women's Premier League. We are also in the making of Mumbai Women's Wheelchair Cricket Team. We have taken trials of a few women players & are planning a first ever Women's Wheelchair Cricket match in Mumbai. </p>
                            <p className="text-justify paragraph">Women's wheelchair cricket teams consist of female athletes with physical disabilities who compete in cricket matches while using wheelchairs. These teams are organized at various levels, including local, national, and international, and they participate in tournaments and competitions specifically tailored for wheelchair cricket.</p>
                            <p className="text-justify paragraph">Women's Wheelchair Cricket Team provides a platform for female athletes with disabilities to showcase their talents, compete at a high level, and contribute to the growth and diversity of the sport. It promotes inclusivity and equal opportunities for women in cricket, regardless of their physical abilities.</p>

                        </div>

                    </div>
                </div>
            </div>


        </>
    )
}

export default Woman